module.exports = __webpack_public_path__ + "static/media/client-linkedin.c24cde28.png";